import React from 'react';
import cn from 'classnames';
import styles from './index.module.less';
import { IProduct } from 'base/interfaces/product';
import transLink from 'base/utils/transLink';
import Link from '@base/lib/ThemeLink';
import { IPoolsVariant } from 'base/interfaces/diyPools';
import { useTrans } from 'base/utils/i18n';

type IProps = {
    product?: IProduct | IPoolsVariant;
    link?: string;
    canJump?: boolean;
    text?: string;
    className?: string;
}

const ListProductSoldOut: React.FC<IProps> = (props) => {
    const { t } = useTrans();
    const {
        product,
        link,
        canJump = true,
        text = t('web_product_sold_out'),
        className,
    } = props;

    const wrapClass = cn(styles['sold-out-link'], className, 'sold-out')

    return canJump ? (
        <Link href={transLink(link || product?.link || '')}>
            <div className={cn(wrapClass, 'js-track-link pointer')}>
                {text}
            </div>
        </Link>
    ) : (
        <div className={wrapClass}>
            {text}
        </div>
    )
}

export default ListProductSoldOut;